import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { Box, ClickAwayListener, FormControl, MenuItem, Select } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { useEffect, useState } from 'react';
import { useTranslation } from '../utility/function/useTranslations';
// import scrollStyle from './addRoom.module.css';

interface RoomObjType {
    adult: number
    child: number
    childAges: (number | null)[]
}
export default function AddRoom(props: any) {
    const { setFieldValue, maxChildAge, fontColor, booknowbuttoncolor, booknowbuttonhovercolor, setEventType, eventType, ishome, brandId, locale } = props;
    const defaultAdults = brandId === 'cfd8297c-a349-4f17-999b-8f5837abed81' ? 1 : 2;
    const [open, setOpen] = useState(false);
    const [roomObj, setRoomObj] = useState<any[]>([{ adult: defaultAdults, child: 0, childAges: [] }]);
    const [adult, setAdult] = useState<number>(2);
    const [child, setChild] = useState<number>(0);
    const [boxHidden, setBoxHidden] = useState(false);
    const { t } = useTranslation();
    const handleCloseFilter = (event: MouseEvent | TouchEvent) => {
        // Don't close if clicking on a Select menu
        const target = event.target as HTMLElement;
        if (target && (
            target.closest('.MuiPaper-root') ||
            target.closest('.MuiMenu-paper') ||
            target.closest('[role="listbox"]')
        )) {
            return;
        }
        // if(open && eventType!="addRoomClick"){
        //     setEventType("");
        // }
        setOpen(false);
    }

    const handleFilterOpen = () => {
        setOpen(prevState => !prevState);
        dropdownPosition();
    };

    const removeRoom = () => {
        const newRoomObj: any[] = [...roomObj];
        if (newRoomObj.length > 1) {
            newRoomObj.pop()
        }
        setRoomObj(newRoomObj);

    }

    const changeCounter = (isIncrement: boolean, index: number, type: string) => {
        const newRoomObj: any = [...roomObj];
        if (isIncrement) {
            newRoomObj[index][type] = newRoomObj[index][type] + 1;
            // When adding a child, add a new age entry (default to 0 - first age)
            if (type === 'child') {
                if (!newRoomObj[index].childAges) {
                    newRoomObj[index].childAges = [];
                }
                newRoomObj[index].childAges.push(0);
            }
        } else {
            newRoomObj[index][type] = newRoomObj[index][type] - 1;
            // When removing a child, remove the last age entry
            if (type === 'child' && newRoomObj[index].childAges && newRoomObj[index].childAges.length > 0) {
                newRoomObj[index].childAges.pop();
            }
        }

        setRoomObj(newRoomObj);
    }

    const dropdownPosition = () => {
        const boxElement = document.getElementById('IBE_AddGuest_Pos');
        if (!boxElement) return;
        const boxPosition = boxElement.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        if (boxPosition.bottom < 0 || (boxPosition.top + boxPosition.bottom) > windowHeight) {
            setBoxHidden(true);
        }
        else {
            setBoxHidden(false);
        }
    }

    const AddRoom = () => {
        const newRoomObj: any[] = [...roomObj];
        newRoomObj.push({ adult: defaultAdults, child: 0, childAges: [] });
        setRoomObj(newRoomObj)
    }

    const handleChildAgeChange = (roomIndex: number, childIndex: number, age: number) => {
        const newRoomObj: any = roomObj.map((room: any, idx: number) => {
            if (idx === roomIndex) {
                const updatedChildAges = [...(room.childAges || [])];
                // Ensure the array is long enough
                while (updatedChildAges.length <= childIndex) {
                    updatedChildAges.push(null);
                }
                updatedChildAges[childIndex] = age;
                return {
                    ...room,
                    childAges: updatedChildAges
                };
            }
            return room;
        });
        setRoomObj(newRoomObj);
    }

    useEffect(() => {
        setAdult(roomObj.reduce((n, { adult }) => n + adult, 0));
        setChild(roomObj.reduce((n, { child }) => n + child, 0));
        updateData()
    }, [roomObj, adult, child])

    const updateData = () => {
        const widgetDataCopy: any = [];

        roomObj.map((data: any, index: number): any => {
            const widgetDataObj = {
                roomCount: index + 1,
                adultCount: data?.adult,
                childCount: data?.child,
                childAges: data?.childAges || []
            }
            return widgetDataCopy.push(widgetDataObj);
        });

        setFieldValue('guest', widgetDataCopy, true);
        // handleCloseFilter();
    }

    const setTableData = {
        removeBorder: {
            borderBottom: 'none !important',
            border: 'none !important'
        },
        plusIconPadding: {
            padding: '16px 16px 5px 16px !important'
        },
        getSameLine: {
            'display': 'flex'
        },
        marginRight: {
            'margin-right': '10px'
        },
        fontBold: {
            'font-size': '14px',
            'font-weight': 'bold',
            'color': '#17202B'
        },
        roomText: {
            color: '#17202B',
            opacity: '56%',
            fontSize: '14px',
            textTransform: 'uppercase',
            display: 'inline-block',
            fontWeight: '700',
            paddingLeft: '15px',
            marginBottom: '0px'
        },
        setAge: {
            color: '#767B82',
            fontSize: '12px',
            marginTop: '5px'
        },
        horizontalLine: {
            border: '1px solid #707070',
            opacity: '0.2',
            marginTop: '10px',
            marginBottom: '10px'
        },
        paddLeft: {
            paddingLeft: '16px !important',
        },
        paddingRight2: {
            paddingRight: '2px !important'
        },
        selectStyle: {
            minWidth: '120px',
            fontSize: '14px',
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#767B82'
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: booknowbuttoncolor ? booknowbuttoncolor : '#2753EB'
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: booknowbuttoncolor ? booknowbuttoncolor : '#2753EB'
            },
            '& .MuiSelect-select': {
                padding: '10px',
                textTransform: 'lowercase',
            }
        },
        childAgeLabel: {
            color: '#17202B',
            fontSize: '14px',
            fontWeight: 'bold',
            marginTop: '10px',
            marginBottom: '5px'
        }
    }

    useEffect(() => {
        const handleScroll = () => {
            dropdownPosition();
        };

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (eventType == '' && open) {
            setOpen(false);
        }
    }, [eventType]);

    return (
        <>
            <ClickAwayListener onClickAway={handleCloseFilter}>
                <Box component="div" className={ishome ? 'addRoomHome' : 'addRoom'} >
                    <Box component="div" id='IBE_AddGuest_Pos' sx={{ textWrap: 'nowrap', color: `${fontColor} !important` }} onClick={() => handleFilterOpen()}>
                        {roomObj.length} {t("common", roomObj.length > 1 ? "rooms" : "room", locale)}, {adult + child} {t("widget", adult > 1 ? 'guests' : 'guest', locale)}
                    </Box>
                    <Box style={{ position: 'relative', marginTop: '15px', marginLeft: "-20px", maxHeight: '494px', overflowY: 'auto', overflowX: 'visible', boxShadow: '0 3px 6px #00000029', borderRadius: '5px', width: 'max-content', display: open ? 'block' : 'none', zIndex: 999, backgroundColor: '#fff', cursor: 'auto' }}>
                        <Box sx={{ p: '20px 15px 10px', marginTop: '14px' }}>
                            <Box component="div" >
                                {roomObj.map((data: any, index: number): any => {
                                    return (
                                        <>
                                            <Box key={index + '_roomIndex'} component="p" sx={setTableData.roomText} style={{ textTransform: "uppercase" }}>{t("common", "room", locale)} {index + 1}</Box>
                                            <TableContainer>
                                                <Table sx={{ mb: '0px !important' }}>
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell width="130px" sx={[setTableData.removeBorder, setTableData.paddLeft, setTableData.paddingRight2]}>
                                                                <Box component="div" sx={setTableData.fontBold} style={{ textTransform: "uppercase" }}>{t("common", "adults", locale)}</Box>
                                                                <Box component="span" sx={setTableData.setAge}>{t("widget", "ages", locale)} {maxChildAge + 1} {t("widget", "orAbove", locale)}</Box>
                                                            </TableCell>
                                                            <TableCell sx={[setTableData.removeBorder, setTableData.getSameLine]}>
                                                                {(data?.adult > 1) &&
                                                                    <Box component="span" sx={{ color: booknowbuttoncolor ? booknowbuttoncolor : '#2753EB', cursor: 'pointer', marginRight: '10px', '&:hover': { 'color': booknowbuttonhovercolor ? booknowbuttonhovercolor : '#4f5f71' } }} onClick={() => changeCounter(false, index, 'adult')}>
                                                                        <RemoveCircleIcon sx={{ fontSize: '21px' }} />
                                                                    </Box>
                                                                }
                                                                {(data?.adult === 1) &&
                                                                    <Box component="span" sx={{ color: '#4f5f71', marginRight: '10px' }}>
                                                                        <RemoveCircleIcon sx={{ fontSize: '21px' }} />
                                                                    </Box>
                                                                }
                                                                <Box component="span" sx={{ marginRight: '10px', fontSize: '14px', fontWeight: 'bold', width: '12px', mt: '1px' }}>{data?.adult}</Box>
                                                                {data?.adult < 25 &&
                                                                    <Box component="span" sx={{ color: booknowbuttoncolor ? booknowbuttoncolor : '#2753EB', cursor: 'pointer', marginRight: '10px', '&:hover': { 'color': booknowbuttonhovercolor ? booknowbuttonhovercolor : '#4f5f71' } }} onClick={() => changeCounter(true, index, 'adult')}>
                                                                        <AddCircleIcon sx={{ fontSize: '21px' }}></AddCircleIcon>
                                                                    </Box>
                                                                }
                                                                {(data?.adult > 24) &&
                                                                    <Box component="span" sx={{ color: '#4f5f71', marginRight: '10px' }} >
                                                                        <AddCircleIcon sx={{ fontSize: '21px' }}></AddCircleIcon>
                                                                    </Box>
                                                                }
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell width="130px" sx={[setTableData.removeBorder, setTableData.paddLeft, setTableData.paddingRight2]}>
                                                                <Box component="div" sx={setTableData.fontBold} style={{ textTransform: "uppercase" }}>{t("widget", "children", locale)}</Box>
                                                                <Box component="span" sx={setTableData.setAge}>{t("widget", "ages", locale)} 0-{maxChildAge}</Box>
                                                            </TableCell>
                                                            <TableCell sx={[setTableData.removeBorder, setTableData.getSameLine]}>
                                                                {data?.child > 0 &&
                                                                    <Box component="span" sx={{ color: booknowbuttoncolor ? booknowbuttoncolor : '#2753EB', cursor: 'pointer', marginRight: '10px', '&:hover': { 'color': booknowbuttonhovercolor ? booknowbuttonhovercolor : '#4f5f71' } }} onClick={() => changeCounter(false, index, 'child')}>
                                                                        <RemoveCircleIcon sx={{ fontSize: '21px' }} />
                                                                    </Box>
                                                                }
                                                                {data?.child === 0 &&
                                                                    <Box component="span" sx={{ color: '#4f5f71', marginRight: '10px' }} >
                                                                        <RemoveCircleIcon sx={{ fontSize: '21px' }} />
                                                                    </Box>
                                                                }
                                                                <Box component="span" sx={{ marginRight: '10px', mt: '1px', fontSize: '14px', fontWeight: 'bold', width: '12px' }}>{data?.child}</Box>
                                                                {data?.child < 24 &&
                                                                    <Box component="span" sx={{ color: booknowbuttoncolor ? booknowbuttoncolor : '#2753EB', cursor: 'pointer', marginRight: '10px', '&:hover': { 'color': booknowbuttonhovercolor ? booknowbuttonhovercolor : '#4f5f71' } }} onClick={() => changeCounter(true, index, 'child')}>
                                                                        <AddCircleIcon sx={{ fontSize: '21px' }} />
                                                                    </Box>
                                                                }
                                                                {data?.child > 23 &&
                                                                    <Box component="span" sx={{ color: '#4f5f71', marginRight: '10px' }}>
                                                                        <AddCircleIcon sx={{ fontSize: '21px' }} />
                                                                    </Box>
                                                                }
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>

                                            {/* Child Age Dropdowns */}
                                            {data?.child > 0 && (
                                                <TableContainer sx={{ mt: '10px' }}>
                                                    <Table sx={{ mb: '0px !important' }}>
                                                        <TableBody>
                                                            {Array.from({ length: data.child }, (_, childIndex) => (
                                                                <TableRow key={`child-age-${index}-${childIndex}`}>
                                                                    <TableCell width="130px" sx={[setTableData.removeBorder, setTableData.paddLeft, setTableData.paddingRight2]}>
                                                                        <Box component="div" sx={setTableData.fontBold}>
                                                                            {t("widget", "child", locale)} {childIndex + 1} Age
                                                                        </Box>
                                                                    </TableCell>
                                                                    <TableCell sx={[setTableData.removeBorder, setTableData.getSameLine]}>
                                                                        <FormControl sx={{ minWidth: '120px', position: 'relative' }}>
                                                                            <Select
                                                                                id={`child-age-select-${index}-${childIndex}`}
                                                                                value={data?.childAges?.[childIndex] != null ? Number(data.childAges[childIndex]) : ''}
                                                                                onChange={(e) => {
                                                                                    e.stopPropagation();
                                                                                    const selectedAge = e.target.value;
                                                                                    if (selectedAge !== '') {
                                                                                        handleChildAgeChange(index, childIndex, Number(selectedAge));
                                                                                    }
                                                                                }}
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                }}
                                                                                displayEmpty
                                                                                sx={setTableData.selectStyle}
                                                                                required
                                                                                MenuProps={{
                                                                                    disablePortal: true,
                                                                                    style: {
                                                                                        zIndex: 9999
                                                                                    },
                                                                                    PaperProps: {
                                                                                        style: {
                                                                                            maxHeight: 200,
                                                                                            zIndex: 9999
                                                                                        }
                                                                                    },
                                                                                    anchorOrigin: {
                                                                                        vertical: 'bottom',
                                                                                        horizontal: 'left',
                                                                                    },
                                                                                    transformOrigin: {
                                                                                        vertical: 'top',
                                                                                        horizontal: 'left',
                                                                                    }
                                                                                }}
                                                                                renderValue={(selected) => {
                                                                                    if (selected.toString() === '' || selected === null || selected === undefined) {
                                                                                        return <span style={{ color: '#000000' }}>{t("widget", "ages", locale)}</span>;
                                                                                    }
                                                                                    const ageValue = typeof selected === 'number' ? selected : Number(selected);
                                                                                    if (isNaN(ageValue)) {
                                                                                        return <span style={{ color: '#000000' }}>{t("widget", "ages", locale)}</span>;
                                                                                    }
                                                                                    return <span style={{ color: '#000000' }}>{ageValue === 0 ? '<1 yr' : `${ageValue} ${ageValue === 1 ? 'yr' : 'yrs'}`}</span>;
                                                                                }}
                                                                            >
                                                                                <MenuItem value="" disabled>
                                                                                    <em>{t("widget", "ages", locale)}</em>
                                                                                </MenuItem>
                                                                                {Array.from({ length: maxChildAge + 1 }, (_, age) => {
                                                                                    return (
                                                                                        <MenuItem style={{ textTransform: 'lowercase' }} key={age} value={age} onClick={(e) => e.stopPropagation()}>
                                                                                            {age === 0 ? '<1 yr' : `${age} ${age === 1 ? 'yr' : 'yrs'}`}
                                                                                        </MenuItem>
                                                                                    );
                                                                                })}
                                                                            </Select>
                                                                        </FormControl>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            )}

                                            {index > 0 && index === roomObj.length - 1 &&
                                                <Box component="p" onClick={removeRoom} sx={{ color: booknowbuttoncolor ? booknowbuttoncolor : '#2753EB', fontSize: '14px', cursor: 'pointer', textAlign: 'right', mt: '0px', mr: '15px' }}>
                                                    {t("widget", "removeRoom", locale)}
                                                </Box>
                                            }
                                            <hr style={setTableData.horizontalLine} />
                                        </>
                                    )
                                })}
                            </Box>
                            {roomObj.length < 5 &&
                                <Box component="p" onClick={() => AddRoom()} sx={{ color: booknowbuttoncolor ? booknowbuttoncolor : '#2753EB', fontSize: '14px', cursor: 'pointer', textAlign: 'right', mt: '20px', mr: '15px' }}>
                                    {t("widget", "addAnotherRoom", locale)}
                                </Box>
                            }
                        </Box>
                    </Box>
                </Box>
            </ClickAwayListener>
        </>
    )
}